import { defineComponent as _defineComponent } from 'vue'
import {ref, inject, watch} from 'vue'

type Props = {
    title: string,
    selectedTitle: string,
    // counter: number
}

export default /*#__PURE__*/_defineComponent({
  __name: 'tab',
  props: {
    title: null,
    selectedTitle: null
  },
  setup(__props: any, { expose }) {
  expose();

const props = __props as {
    title: string,
    selectedTitle: string,
    // counter: number
}



const active = ref(false);
const selectedTab = inject<{selectedTab: string}>("selectedTab")

watch(() => selectedTab?.selectedTab, () => active.value = selectedTab?.selectedTab === props.title)



const __returned__ = { props, active, selectedTab, ref, inject, watch }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})